<template>
  <div id="mainBox">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <el-alert
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 12px"
      title="本列表展示未关联寄售子单的官方寄售成交单（如 Excel 导入），需平台代发货给买家；已关联寄售单且走鉴别流程的订单仍在「待发货列表」。"
    />

    <div class="flex search-box">
      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">商品编号：</span>
        <div style="width: 132px">
          <el-input v-model="query.productNo" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
        <div style="width: 180px">
          <el-input v-model="query.orderNo" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">时间：</span>
        <div style="width: 290px">
          <el-date-picker
            v-model="query.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </div>
      </div>
    </div>

    <div class="operate-btns">
      <el-button type="success" size="medium" @click="searchFn">搜索</el-button>
      <el-button size="medium" @click="resetFn">重置</el-button>
      <el-button type="primary" size="medium" @click="copyAllAddresses">复制所有地址</el-button>
    </div>

    <el-tabs v-model="activeStatusTab" type="card" class="status-tabs" @tab-click="handleStatusTabClick">
      <el-tab-pane v-for="t in statusTabs" :key="t.name" :label="t.label" :name="t.name" />
    </el-tabs>

    <div class="table-scroll-wrap">
    <el-table
      class="data-table"
      :data="tableData"
      border
      style="width: 100%; margin-top: 12px"
      v-loading="loading"
    >
      <el-table-column prop="orderNo" width="170" align="center" label="订单号" />
      <el-table-column prop="productNo" width="120" align="center" label="商品编号">
        <template slot-scope="scope">
          <span v-if="scope.row.productNo">{{ scope.row.productNo }}</span>
          <span v-else style="color: #999">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="importSeq" width="90" align="center" label="导入序号">
        <template slot-scope="scope">
          <span v-if="scope.row.importSeq">{{ scope.row.importSeq }}</span>
          <span v-else style="color: #999">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="importCode" width="90" align="center" label="代号">
        <template slot-scope="scope">
          <span v-if="scope.row.importCode">{{ scope.row.importCode }}</span>
          <span v-else style="color: #999">-</span>
        </template>
      </el-table-column>
      <el-table-column label="商品信息" min-width="220" align="center">
        <template slot-scope="scope">
          <div style="line-height: 1.6; text-align: left">
            <div v-if="scope.row.productTitle">{{ scope.row.productTitle }}</div>
            <div v-if="brandDisplay(scope.row)">品牌：{{ brandDisplay(scope.row) }}</div>
            <div v-if="typeDisplay(scope.row)">型号：{{ typeDisplay(scope.row) }}</div>
            <div v-if="scope.row.gradeLevel">评级：{{ scope.row.gradeLevel }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="实付(元)" width="100" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.totalAmount) }}</template>
      </el-table-column>
      <el-table-column label="买家" width="140" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatUserDisplay(scope.row.buyerNickName, scope.row.buyerScentId) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="货主" width="140" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatUserDisplay(scope.row.consignorNickName, scope.row.consignorScentId) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收货人" width="100" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ receiverSnap(scope.row).name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" width="120" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="receiver-phone">{{ receiverSnap(scope.row).phone || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收货地址" min-width="220" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="receiver-addr">
            <div v-if="receiverSnap(scope.row).region" class="receiver-addr__region">
              {{ receiverSnap(scope.row).region }}
            </div>
            <div class="receiver-addr__detail">
              {{ receiverDetailLine(scope.row) }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="payTime" width="160" align="center" label="支付时间">
        <template slot-scope="scope">{{ formatTime(scope.row.payTime) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center" fixed="right">
        <template slot-scope="scope">
          <span :style="{ color: statusColor(scope.row.status) }">{{ statusLabel(scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="220" align="left" label="操作" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; flex-wrap: wrap; gap: 6px; justify-content: flex-start;">
            <el-button type="primary" size="small" @click="showDetailDialog(scope.row)">详情</el-button>
            <el-button
              v-if="Number(scope.row.status) === 1"
              type="success"
              size="small"
              @click="confirmDelivery(scope.row)"
            >确认发货</el-button>
            <el-button
              v-if="Number(scope.row.status) === 2"
              type="warning"
              size="small"
              :loading="confirmReceiveLoadingId === scope.row.id"
              @click="confirmReceive(scope.row)"
            >确认收货</el-button>
            <el-button type="info" size="small" @click="copyAddress(scope.row)">复制地址</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <el-dialog title="成交单详情" :visible.sync="detailVisible" width="720px" :close-on-click-modal="false">
      <div v-loading="detailLoading">
        <el-descriptions v-if="detail" :column="2" border size="small">
          <el-descriptions-item label="订单号" :span="2">{{ detail.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="商品编号">{{ detail.productNo || "-" }}</el-descriptions-item>
          <el-descriptions-item label="商品">{{ detail.productTitle }}</el-descriptions-item>
          <el-descriptions-item label="评级">{{ detail.gradeLevel || "-" }}</el-descriptions-item>
          <el-descriptions-item label="实付">{{ formatMoney(detail.totalAmount) }} 元</el-descriptions-item>
          <el-descriptions-item label="状态">{{ statusLabel(detail.status) }}</el-descriptions-item>
          <el-descriptions-item label="买家">{{ formatUserDisplay(detail.buyerNickName, detail.buyerScentId) }}</el-descriptions-item>
          <el-descriptions-item label="货主">{{ formatConsignorDetail(detail) }}</el-descriptions-item>
          <el-descriptions-item label="收货人">{{ receiverSnap(detail).name || "-" }}</el-descriptions-item>
          <el-descriptions-item label="电话">{{ receiverSnap(detail).phone || "-" }}</el-descriptions-item>
          <el-descriptions-item label="省市区" :span="2">{{ receiverSnap(detail).region || "-" }}</el-descriptions-item>
          <el-descriptions-item label="详细地址" :span="2">{{ receiverDetailLine(detail) }}</el-descriptions-item>
          <el-descriptions-item label="支付时间">{{ formatTime(detail.payTime) }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ formatTime(detail.createTime) }}</el-descriptions-item>
          <el-descriptions-item v-if="detail.logisticsCompany" label="物流">{{ detail.logisticsCompany }} {{ detail.logisticsNo }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

    <el-dialog title="确认发货" :visible.sync="shipVisible" width="520px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="订单号">
          <div>{{ shipForm.orderNo }}</div>
        </el-form-item>
        <el-form-item label="收货人">
          <div>{{ shipForm.receiverName }}</div>
        </el-form-item>
        <el-form-item label="联系电话">
          <div>{{ shipForm.receiverPhone }}</div>
        </el-form-item>
        <el-form-item v-if="shipForm.receiverRegion" label="省市区">
          <div>{{ shipForm.receiverRegion }}</div>
        </el-form-item>
        <el-form-item label="详细地址">
          <div>{{ shipForm.receiverDetail || shipForm.receiverAddress || "-" }}</div>
        </el-form-item>
        <el-form-item label="物流公司" required>
          <el-select v-model="shipForm.expressCompany" placeholder="请选择物流公司" filterable style="width: 100%">
            <el-option v-for="item in companyData" :key="item.code" :label="item.title" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" required>
          <el-input v-model="shipForm.expressNo" placeholder="请填写物流单号" maxlength="60" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shipVisible = false">取消</el-button>
        <el-button type="success" :loading="shipLoading" @click="submitShip">确认发货</el-button>
      </span>
    </el-dialog>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />
  </div>
</template>

<script>
import historyTag from "@/components/historyTag";
import expressInfo from "@/util/expressInfo";
import { api } from "@/util/requestUrl";
import { resolveCreateTimeRange } from "@/util/inspectionJobTimeRange";
import { decodeUnicodeEscapes } from "@/util/utils";

export default {
  components: { historyTag },
  data() {
    return {
      historyArr: ["鉴别作业", "官方寄售待发货"],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      loading: false,

      activeStatusTab: "1",
      statusTabs: [
        { label: "待发货", name: "1", value: 1 },
        { label: "待收货", name: "2", value: 2 },
      ],

      query: {
        timeRange: null,
        orderNo: "",
        productNo: "",
      },

      detailVisible: false,
      detailLoading: false,
      detail: null,

      shipVisible: false,
      shipLoading: false,
      confirmReceiveLoadingId: null,
      companyData: expressInfo.arr || [],
      shipForm: {
        id: null,
        orderNo: "",
        receiverName: "",
        receiverPhone: "",
        receiverRegion: "",
        receiverDetail: "",
        receiverAddress: "",
        expressCompany: "",
        expressNo: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    buildListParams() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        orderNo: this.query.orderNo || null,
        status: this.activeStatusTab === "2" ? 2 : 1,
      };
      const productNo = String(this.query.productNo || "").trim();
      if (productNo) {
        params.filterProductNo = productNo;
      }
      Object.assign(params, resolveCreateTimeRange(this.query.timeRange));
      return params;
    },

    getList() {
      this.loading = true;
      this.$axios
        .post(api.officialConsignTradePendingList, this.buildListParams())
        .then((res) => {
          this.loading = false;
          if (res.data.code === 200) {
            const page = res.data.data || {};
            this.tableData = page.records || [];
            this.tableTotal = page.total || 0;
          } else {
            this.$message.error(res.data.msg || "获取列表失败");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("网络异常");
        });
    },

    searchFn() {
      this.currentPage = 1;
      this.getList();
    },

    resetFn() {
      this.query = { timeRange: null, orderNo: "", productNo: "" };
      this.activeStatusTab = "1";
      this.currentPage = 1;
      this.getList();
    },

    handleStatusTabClick() {
      this.currentPage = 1;
      this.getList();
    },

    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    handlePageSizeChange() {
      this.getList();
    },

    showDetailDialog(row) {
      this.detailVisible = true;
      this.detailLoading = true;
      this.detail = null;
      this.$axios
        .get(api.getSecondhandOrderById, { params: { id: row.id } })
        .then((res) => {
          this.detailLoading = false;
          if (res.data.code === 200) {
            const o = res.data.data || {};
            this.detail = Object.assign({}, row, o);
          } else {
            this.$message.error(res.data.msg || "加载详情失败");
          }
        })
        .catch(() => {
          this.detailLoading = false;
          this.$message.error("网络异常");
        });
    },

    confirmDelivery(row) {
      const snap = this.receiverSnap(row);
      this.shipForm = {
        id: row.id,
        orderNo: row.orderNo || "",
        receiverName: snap.name || "",
        receiverPhone: snap.phone || "",
        receiverRegion: snap.region || "",
        receiverDetail: snap.detail || "",
        receiverAddress: snap.full || "",
        expressCompany: "",
        expressNo: "",
      };
      this.shipVisible = true;
    },

    submitShip() {
      const f = this.shipForm || {};
      const company = (f.expressCompany || "").trim();
      if (!company) {
        this.$message.error("请选择物流公司");
        return;
      }
      const no = (f.expressNo || "").trim();
      if (!no) {
        this.$message.error("请填写物流单号");
        return;
      }
      this.shipLoading = true;
      this.$axios
        .post(api.updateSecondhandOrder, {
          id: f.id,
          logisticsCompany: company,
          logisticsNo: no,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("已确认发货");
            this.shipVisible = false;
            this.getList();
          } else {
            this.$message.error(res.data.msg || "操作失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.shipLoading = false;
        });
    },

    confirmReceive(row) {
      if (!row || !row.id) {
        this.$message.error("订单无效");
        return;
      }
      this.$confirm(
        `确认代买家确认收货？订单 ${row.orderNo || row.id} 确认后将触发分账，且无法再申请退款。`,
        "确认收货",
        { type: "warning", confirmButtonText: "确认收货", cancelButtonText: "取消" }
      )
        .then(() => {
          this.confirmReceiveLoadingId = row.id;
          this.$axios
            .post(api.officialConsignTradeConfirmReceive, { orderId: row.id })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success("确认收货成功");
                this.getList();
              } else {
                this.$message.error(res.data.msg || "确认收货失败");
              }
            })
            .catch(() => {
              this.$message.error("网络异常");
            })
            .finally(() => {
              this.confirmReceiveLoadingId = null;
            });
        })
        .catch(() => {});
    },

    copyAddress(row) {
      const snap = this.receiverSnap(row);
      const address = `${snap.name || ""} ${snap.phone || ""} ${snap.full || ""}（${row.orderNo || "-"}）`;
      this.copyToClipboard(address.trim());
      this.$message.success("地址已复制");
    },

    copyAllAddresses() {
      const params = this.buildListParams();
      delete params.page;
      delete params.size;
      this.$axios
        .post(api.officialConsignTradeCopyAddresses, params)
        .then((res) => {
          if (res.data.code === 200) {
            const addresses = res.data.data;
            if (addresses) {
              this.copyToClipboard(addresses);
              this.$message.success("所有地址已复制");
            } else {
              this.$message.warning("没有待发货地址");
            }
          } else {
            this.$message.error(res.data.msg || "获取地址失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        });
    },

    copyToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },

    displayText(val) {
      if (val == null || val === "") return "";
      return decodeUnicodeEscapes(String(val).trim()) || "";
    },

    formatUserDisplay(nick, scentId) {
      const parts = [];
      const n = this.displayText(nick);
      const s = String(scentId || "").trim();
      if (n) parts.push(n);
      if (s) parts.push(s);
      return parts.length ? parts.join(" · ") : "-";
    },

    formatConsignorDetail(detail) {
      if (!detail) return "-";
      const p = detail.product;
      const nick = (p && p.consignorNickName) || detail.consignorNickName;
      const scent = (p && p.consignorScentId) || detail.consignorScentId;
      return this.formatUserDisplay(nick, scent);
    },

    safeJsonParse(str) {
      if (!str) return null;
      const text = String(str).trim();
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch (e) {
        return null;
      }
    },

    parseAddressObject(d) {
      if (!d) return null;
      const fromJson = this.safeJsonParse(d.buyerAddressJson);
      if (fromJson && typeof fromJson === "object") return fromJson;
      const fromReceiver = this.safeJsonParse(d.receiverAddress);
      if (fromReceiver && typeof fromReceiver === "object") return fromReceiver;
      const fromBuyer = this.safeJsonParse(d.buyerAddress);
      if (fromBuyer && typeof fromBuyer === "object") return fromBuyer;
      return null;
    },

    normalizeAddressSnapshot(o) {
      if (!o || typeof o !== "object") return { name: "", phone: "", region: "", detail: "", full: "" };
      const pick = (keys) => {
        for (const k of keys) {
          const v = o[k];
          if (v != null && String(v).trim()) return String(v).trim();
        }
        return "";
      };
      const name = this.displayText(pick(["name", "userName", "receiverName", "consignee", "buyerName"]));
      const phone = pick(["phone", "mobile", "tel", "telephone", "receiverPhone", "consigneePhone", "buyerPhone"]);
      const province = this.displayText(pick(["province", "provinceName"]));
      const city = this.displayText(pick(["city", "cityName"]));
      let district = "";
      if (Array.isArray(o.area)) {
        district = this.displayText(o.area.map((x) => String(x || "").trim()).filter(Boolean).join(" "));
      }
      if (!district) {
        district = this.displayText(pick(["area", "district", "districtName", "county", "countyName"]));
      }
      // street/town 与 detail 拼接（去重）
      const street = this.displayText(pick(["street", "town"]));
      let detail = this.displayText(pick(["detail", "detailAddress", "addressDetail", "addr"]));
      if (street && (!detail || detail.indexOf(street) < 0)) {
        detail = detail ? street + detail : street;
      }
      const region = [province, city, district].filter(Boolean).join(" ");
      const full = [region, detail].filter(Boolean).join(" ");
      return { name, phone, province, city, district, detail, region, full };
    },

    buyerAddrSnap(d) {
      const parsed = this.parseAddressObject(d);
      if (parsed) {
        const snap = this.normalizeAddressSnapshot(parsed);
        if (!snap.name) {
          snap.name = this.displayText(d && d.receiverName || d && d.buyerName);
        }
        if (!snap.phone) {
          snap.phone = String((d && d.receiverPhone) || (d && d.buyerPhone) || "").trim();
        }
        return snap;
      }
      const name = this.displayText(d && d.receiverName || d && d.buyerName);
      const phone = String((d && d.receiverPhone) || (d && d.buyerPhone) || "").trim();
      const region = this.displayText(d && d.receiverRegion);
      const detail = this.displayText(d && d.receiverDetail);
      const rawAddr = d && d.receiverAddress || d && d.buyerAddress;
      const fullAddr = this.isJsonLike(rawAddr) ? "" : this.displayText(rawAddr);
      const full = fullAddr || [region, detail].filter(Boolean).join(" ");
      return { name, phone, region, detail, full };
    },

    isJsonLike(val) {
      const s = String(val || "").trim();
      return s.startsWith("{") && s.endsWith("}");
    },

    receiverSnap(row) {
      return this.buyerAddrSnap(row || {});
    },

    receiverDetailLine(row) {
      const snap = this.receiverSnap(row);
      if (snap.detail) return snap.detail;
      const raw = row && row.receiverAddress || row && row.buyerAddress;
      if (this.isJsonLike(raw)) return "-";
      const text = this.displayText(raw);
      if (text && snap.region && text.indexOf(snap.region) === 0) {
        return text.slice(snap.region.length).trim() || text;
      }
      return text || snap.full || "-";
    },

    brandDisplay(row) {
      if (!row) return "";
      const cn = row.brandName || "";
      const en = row.brandEnglishName || "";
      if (cn && en) return cn + " - " + en;
      return cn || en || "";
    },

    typeDisplay(row) {
      if (!row) return "";
      const cn = row.typeName || "";
      const en = row.typeEnglishName || "";
      if (cn && en) return cn + " - " + en;
      return cn || en || "";
    },

    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(2) : "-";
    },

    formatTime(time) {
      if (!time) return "-";
      const date = new Date(time);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      const h = String(date.getHours()).padStart(2, "0");
      const mi = String(date.getMinutes()).padStart(2, "0");
      const s = String(date.getSeconds()).padStart(2, "0");
      return `${y}-${m}-${d} ${h}:${mi}:${s}`;
    },

    statusLabel(v) {
      const m = { 1: "待发货", 2: "待收货", 3: "待评价", 4: "已完成", 5: "已退款", 6: "已取消", 7: "退款中" };
      return m[v] != null ? m[v] : "未知";
    },

    statusColor(v) {
      if (v === 1) return "#E6A23C";
      if (v === 2) return "#409EFF";
      if (v === 5 || v === 6) return "#909399";
      return "#333";
    },
  },
};
</script>

<style scoped>
.historyTag {
  width: 100%;
  box-sizing: border-box;
}

#mainBox {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.search-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0;
  row-gap: 8px;
  column-gap: 12px;
}

.search-item {
  display: flex;
  align-items: center;
}

.operate-btns {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 12px;
  gap: 10px;
}

.status-tabs {
  margin-top: 4px;
}

.data-table {
  padding: 0 20px;
}

.receiver-phone {
  font-family: Menlo, Monaco, Consolas, monospace;
}

.receiver-addr {
  line-height: 1.5;
  text-align: left;
}

.receiver-addr__region {
  color: #606266;
}

.receiver-addr__detail {
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/pages/officialConsignTrade/pendingDeliveryList.vue